import { zodResolver } from '@hookform/resolvers/zod';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { string, z } from 'zod';
import Button from '../atoms/Button';
import InputBox from '../atoms/InputBox';

const SignIn = ({
    setUser,
    setStep,
    isError,
    toggleSignUpAndSignIn,
    errorMessage,
    isLoading,
    handleSignInFormSubmit,
    defaultEmail,
    ...property
}) => {
    const signInSchema = z.object({
        email: string()
            .min(1, { message: 'Please enter your Email ID' })
            .email('Please enter a valid Email ID to continue!')
    });

    const { register, handleSubmit, formState,watch } = useForm({
        defaultValues: { email: defaultEmail },
        resolver: zodResolver(signInSchema)
    });

    const { errors } = formState;

    return (
        <form
            onSubmit={handleSubmit(handleSignInFormSubmit)}
            className={`flex flex-col space-y-6 mt-8 w-full ${property.className}`}
        >
            <div>
                <InputBox
                    isError={!!errors.email}
                    type="email"
                    placeholder="Email"
                    variant="Large"
                    errorMessage={
                        errors.email
                            ? errors.email.message
                            : errorMessage.message
                    }
                    dbName="email"
                    register={register}
                />
                {errorMessage.show && (
                    <span className="text-red-500 text-sm font-normal mt-2">
                        {errorMessage.message}
                    </span>
                )}
            </div>
            <Button
                label="Sign In"
                size="medium"
                type="submit"
                disabled={isLoading}
            />

            <Button
                label="Sign Up"
                onClick={()=>toggleSignUpAndSignIn(watch('email'))}
                size="medium"
                style="ghost"
            />
        </form>
    );
};

SignIn.propTypes = {
    className: PropTypes.string,
    errorMessage: PropTypes.object
};

export default SignIn;
